import httpClient from '@/http-client'

export const store = data => {
  return httpClient
    .post('/api/v1/payroll-cycles', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const get = (options = {}) => {
  return httpClient
    .get('/api/v1/payroll-cycles', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const update = (id, data) => {
  return httpClient
    .put(`/api/v1/payroll-cycles/${id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const destroy = id => {
  return httpClient
    .delete(`/api/v1/payroll-cycles/${id}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export default { store, get, update, destroy }
